module.exports = __webpack_public_path__ + "img/network-analyzer-sm.a6f0ae43.svg";